export const AVAILABLE_LOCALES = ["fr-FR"];
export const DEFAULT_LANGUAGE_KEY = "i18nDefaultLanguage";
export const FIRST_DAY_OF_WEEK_PER_LOCALE: Record<string, number> = {
    "fr-FR": 1,
};

export const findFirstDayOfWeek = (locale: string): number => {
    return FIRST_DAY_OF_WEEK_PER_LOCALE[locale] ?? 0;
};
